<div class="cd-section" id="regulations" style="background-color: white; padding-top:10px;">

    <div class="container-fluid">
        <!-- Header -->
        <div class="row ">
            <div class="header-container neg-lift ">
                <img class="image1" width="100%" src="../../assets/img/RegScale-Mock1.png" alt="" />

                <div class="top-left col-md-4">
                        <h5 class="top-leftText" >Become a master of Continuous Compliance with RegScale University and help bring compliance into the modern era. We offer everything from tutorials, online hands-on training, and community forums - all with just a few clicks. Let’s start learning.</h5>
                </div>

            </div>
            <img class="image2" width="100%" src="../../assets/img/RegScale-University Mobile.png" alt="" />
        </div>

        <!-- ONE Section Half -->
        <div class="row">

            <!-- left side -->
            <div class="col-md-4 offset-md-1 cardPosition" >
            
                <div class="supportcard">
            
                    <h1 class="trainingHeader"><b>Support</b></h1>
                    <h5> No matter your experience level, we have the tools for success. Check out our library of training videos to
                        get started. <br>
                        <div>
                            <a class="btn btn-primary mb-2 mt-2" [routerLink]="['/training/roles']"> View Training Videos</a>
                        </div>
                        For Enterprise Edition customers, get your exclusive access to hands-on training and our extended training
                        catalog.
                    </h5>
                    <div>
                        <a class="btn btn-primary" [routerLink]="['/comingsoon']"> Enterprise Training</a>
                    </div>
                    <br>
                    <br>
                </div>
            </div>

            <!-- right side  -->
            <div class="col-md-6">
                <div>
                    <h1  class="trainingHeader"><b>Community</b></h1>
                </div>

                <div>
                    <img style="height:60px; width:auto;" src="../../assets/img/Users-PFP.png" alt="User Photos">
                </div>

                <div>
                    <h5>
                        Collaborate with RegOps experts and other RegScale users in our community forums, join exclusive community events and Q&A sessions, and learn what’s new in the platform in our exclusive community.
                    </h5>
                </div>

                
                <div>
                    <a class="btn btn-primary" href="https://community.regscale.com/sign_in"> Join the RegOps Community</a>
                </div>
            </div>

        </div>

        <!-- TWO Section Half -->
        <div class="row top-buffer">

            <div class="body-container col-md-6">
                <img class="image3" width="100%" src="../../assets/img/RegScale-Mock2.png" alt="" />

            </div>
            <img class="image4" width="100%" src="../../assets/img/RegScale-University Mobile 2.png" alt="" />

            <div class="col-md-6 pro" style=" margin-top: 10%;">
                <h1 class="trainingHeader"> <b>Become a RegScale Pro</b></h1>

                <h5> Become a certified RegScale user with hands-on training once you become a customer.</h5>

                <div>
                    <a class="btn btn-primary" [routerLink]="['/comingsoon']"> Learn More</a>
                </div>
            </div>

        </div>

        <div class="blog">

        <!-- A listing of the three most recent blogs -->
        <recent-blogs></recent-blogs>
</div>

    </div>
</div>